module.exports = __webpack_public_path__ + "static/Goldpartnertime-a977f19ae9108cb7710f13914bbf682c.png";